function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 140,
  fill: "white",
  fillOpacity: 0.9
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M93.4485 72.5405C93.4485 81.2682 95.6975 85.4011 100.588 85.4011C105.478 85.4011 107.733 81.2682 107.733 72.5405C107.733 63.8201 105.478 59.6326 100.588 59.6326C95.6975 59.6326 93.4485 63.8201 93.4485 72.5405ZM118.344 72.5405C118.344 83.355 111.352 90.0382 100.588 90.0382C89.8307 90.0382 82.8379 83.355 82.8379 72.5405C82.8379 61.7254 89.8307 55 100.588 55C111.352 55 118.344 61.7254 118.344 72.5405Z",
  fill: "#0068B7"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48 68.7296V56.312H80.4538V68.7296H75.9098C75.9098 63.7433 74.4448 60.6129 68.8237 60.6129V82.4659C68.8237 83.684 69.5083 84.4168 70.7257 84.4168H73.657V88.723H54.6921V84.4168H57.7273C58.9443 84.4168 59.6353 83.684 59.6353 82.4659V60.6129C54.0084 60.6129 52.5422 63.7433 52.5422 68.7296H48Z",
  fill: "#0068B7"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M124.66 62.5767C124.66 61.3517 123.974 60.6179 122.755 60.6179H119.717V56.312H140.227C148.251 56.312 152.998 58.8109 152.998 65.5179C152.998 72.2189 148.251 74.765 139.244 74.765H133.859V82.4964C133.859 83.717 134.55 84.4498 135.769 84.4498H139.05V88.7618H119.766V84.4498H122.755C123.974 84.4498 124.66 83.717 124.66 82.4964V62.5767H124.66ZM133.859 70.4541H138.067C141.495 70.4541 143.794 68.5982 143.794 65.5602C143.794 62.5278 141.592 60.6179 138.849 60.6179H133.859V70.4541Z",
  fill: "#0068B7"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M205.914 56.3018L213.621 80.7468C214.596 83.729 215.279 84.4135 216.99 84.4135H218.188V88.7204H200.805V84.4135H202.272C203.739 84.4135 204.962 84.2192 204.962 83.6801C204.962 83.1956 204.914 82.657 204.722 81.9229L203.69 78.4032H194.185L193.598 80.3607C193.058 82.069 192.865 82.8018 192.865 83.4864C192.865 84.2688 194.573 84.4135 195.894 84.4135H197.31V88.7204H182.94V84.4135H184.599C186.316 84.4135 187.001 83.729 187.975 80.7468L196.143 56.3018H205.914V56.3018ZM195.603 74.1014H202.224L199.17 63.5901H199.074L195.603 74.1014Z",
  fill: "#0068B7"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M248.731 78.6594H248.827V62.5639C248.827 61.3405 248.143 60.6068 246.917 60.6068H243.936V56.3018H258.999V60.6068H256.064C254.842 60.6068 254.162 61.3405 254.162 62.5639V88.7407H244.28L230.683 64.6199H230.588V82.478C230.588 83.6966 231.272 84.43 232.497 84.43H235.479V88.7407H220.358V84.43H223.347C224.565 84.43 225.251 83.6966 225.251 82.478V62.5639C225.251 61.3405 224.565 60.6068 223.347 60.6068H220.31V56.3018H236.067L248.731 78.6594Z",
  fill: "#0068B7"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M159.486 62.5868C159.486 61.3621 158.8 60.6283 157.581 60.6283H154.542V56.3228H175.052C183.076 56.3228 187.825 58.8217 187.825 65.5283C187.825 72.2293 183.076 74.7758 174.07 74.7758H168.685V82.5078C168.685 83.7258 169.376 84.4612 170.594 84.4612H173.876V88.7731H154.592V84.4612H157.581C158.8 84.4612 159.486 83.7258 159.486 82.5078V62.5868ZM168.685 70.4645H172.894C176.321 70.4645 178.619 68.6086 178.619 65.5702C178.619 62.5389 176.417 60.6283 173.676 60.6283H168.685V70.4645Z",
  fill: "#0068B7"
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: -4,
  y: -4,
  width: 314,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgLogoToppan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 140,
    viewBox: "0 0 306 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoToppan);
export default __webpack_public_path__ + "static/media/logo_toppan.b6141065.svg";
export { ForwardRef as ReactComponent };